// TooltipCleaner.js
import { useEffect } from "react";

const TooltipCleaner = () => {
  useEffect(() => {
    const clearTooltips = () => {
      // Clear any existing tooltips, including chartjs-time-tooltip and chartjs-custom-tooltip
      let tooltipContainers = document.querySelectorAll(
        ".chartjs-tooltip, .chartjs-custom-tooltip, #chartjs-time-tooltip"
      );

      tooltipContainers.forEach((tooltip) => {
        tooltip.parentNode.removeChild(tooltip); // Remove tooltips from DOM
      });
    };

    // Clear tooltips on initial load
    clearTooltips();

    // Listen for history navigation (e.g., pressing the "Back" button)
    window.addEventListener("popstate", clearTooltips);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener("popstate", clearTooltips);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default TooltipCleaner;
